module.exports = "\n<div class=\"container under-construction-wrapper\">\n  <div class=\"row\">\n    <div class=\"col-md-12 text-center\">\n        <img src=\"..\\..\\..\\assets\\images\\under-construction.svg\" />\n        <h2 class=\"text-uppercase\">Ooops...!!</h2>\n        <h3 class=\"text20\">Feature under construction.</h3>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/under-construction/under-construction.component.html
// module id = ./src/app/feature/main/roles-shared/components/under-construction/under-construction.component.html
// module chunks = main